const iotv = require('./components');
const req = require.context('./components', true, /^\.\/locale-provider\/.+_.+\.tsx$/);

iotv.locales = {};

req.keys().forEach((mod) => {
  const match = mod.match(/\/([^/]+).tsx$/);
  iotv.locales[match[1]] = req(mod);
});

module.exports = iotv;



// WEBPACK FOOTER //
// ./index-with-locales.js